/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { theme } from '../../styles/theme'
import { CalculatorData } from '../../types'

interface CalculatorTableProps {
  data: CalculatorData[]
}

const tableContainerStyles = css`
  border: 1px solid #e9ecef;
  border-radius: 8px;
  min-height: 400px;
  background: white;
  overflow-y: auto;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    min-height: 300px;
    zoom: 0.8;
  }
`

const tableStyles = css`
  .table th {
    background-color: ${theme.colors.primary};
    color: white;
    border: none;
    position: sticky;
    top: 0;
    z-index: 10;
    font-weight: 600;
  }
  
  .table td {
    border-color: rgba(41, 117, 186, 0.15);
    vertical-align: middle;
  }
  
  .table-striped > tbody > tr:nth-of-type(odd) > td {
    background-color: rgba(41, 117, 186, 0.03);
  }
`

const emptyStateStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  color: #6c757d;
  
  i {
    font-size: 3rem;
    margin-bottom: 1rem;
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    height: 300px;
  }
`

const formatCurrency = (value: number): string => {
  return '$' + value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })
}

export const CalculatorTable = ({ data }: CalculatorTableProps) => {
  if (!data.length) {
    return (
      <div css={tableContainerStyles}>
        <div css={emptyStateStyles}>
          <i className="fas fa-table"></i>
          <p>Table will appear here after calculation</p>
        </div>
      </div>
    )
  }

  return (
    <div css={[tableContainerStyles, tableStyles]}>
      <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <table className="table table-striped table-hover">
          <thead className="table-primary">
            <tr>
              <th>Year</th>
              <th>Account Value</th>
              <th>Annual Growth</th>
              <th>Contributions</th>
              <th>Total Growth</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td>{row.year}</td>
                <td>{formatCurrency(row.value)}</td>
                <td>{formatCurrency(row.growth)}</td>
                <td>{formatCurrency(row.contributions)}</td>
                <td>{formatCurrency(row.totalGrowth)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}